import React from "react";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import cx from "classnames";

import { showToast } from "../Toast";
import { subscribeNewsletter } from "../../client";
import MenuArrowIcon from "../../assets/svgs/menu-arrow-next.svg";

import "./newsletterSignupForm.scss";

export const NEWSLETTER_NAME = {
  ZIPWORLD: "ZipWorld Monthly Newsletter",
  WEEKLY: "Weekly Newsletter",
};

const NewsletterSignupForm = ({
  newsletterName = NEWSLETTER_NAME.WEEKLY,
  toastId,
  buttonClassNames = "btn btn-primary mb-2 subscribe-form-right",
  inputClassNames = "form-control mb-2 mr-sm-0 subscribe-form-left",
  showButtonArrow = false,
  classNames,
  ...props
}) => {
  const { t, i18n } = useTranslation();
  const {
    buttonText = t("form.newsletterSignUpForm.btnSubscribe"),
    inputPlaceHolder = t("form.newsletterSignUpForm.enterYourEmail"),
  } = props;

  const NewsletterCountry = (lang) =>
    ({
      en: "Global",
      au: "AU",
      th: "TH",
      id: "ID",
    }[lang.split("_")[0]]);

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      const fieldValues = [];
      if (newsletterName === NEWSLETTER_NAME.ZIPWORLD) {
        fieldValues.push({
          field: "143",
          value: `ZipWorld_${NewsletterCountry(i18n.language)}`,
        });
      } else {
        fieldValues.push(
          {
            field: "28",
            value: NewsletterCountry(i18n.language),
          },
          {
            field: "37",
            value: newsletterName,
          }
        );
      }

      try {
        await subscribeNewsletter({
          contact: {
            email: values.email,
            fieldValues,
          },
        });

        if (toastId) {
          showToast(toastId, "success");
        } else {
          alert(t("form.newsletterSignUpForm.alert"));
        }

        setSubmitting(false);
        resetForm();
      } catch (error) {
        if (toastId) {
          showToast(toastId, "error");
        } else {
          alert("Something went wrong. Please try again later.");
        }
      }
    },
  });

  return (
    <form
      className={cx(
        "form-inline subscribe-form flex-column flex-md-row justify-content-center justify-content-md-start",
        classNames
      )}
      onSubmit={formik.handleSubmit}
    >
      <input
        className={inputClassNames}
        id="email"
        name="email"
        type="email"
        placeholder={inputPlaceHolder}
        onChange={formik.handleChange}
        value={formik.values.email}
      />
      <button
        id="subscribe-form__btn"
        disabled={!(formik.isValid && formik.dirty) || formik.isSubmitting}
        type="submit"
        className={buttonClassNames}
      >
        {buttonText}
        {showButtonArrow && <MenuArrowIcon className="ml-2" />}
      </button>
    </form>
  );
};

export default NewsletterSignupForm;
